import { renderLineBreaks } from "../../../utils";
import { NextImage } from "..";
import {
  TaskItemGridWrapper,
  TaskItemWrapper,
  TaskItemTitleWrapper,
  DescriptionWrapper,
} from "./styles";
import EditorJSContent from "../../editor-js-content";

const Description = ({ children, richText, ...cardProps }) => {
  return (
    <DescriptionWrapper {...cardProps}>
      {richText ? (
        <EditorJSContent content={richText} />
      ) : (
        <p>{renderLineBreaks(children)}</p>
      )}
    </DescriptionWrapper>
  );
};

export const CardItem = ({
  title,
  body,
  icon,
}) => {

  return (
    <TaskItemGridWrapper >
      <TaskItemWrapper >
        <TaskItemTitleWrapper>
          {icon && <NextImage media={icon} alt={title} /> }
          {title}
        </TaskItemTitleWrapper>
        {body &&
        <DescriptionWrapper>
           <EditorJSContent content={body} />
         </DescriptionWrapper>
        }
      </TaskItemWrapper>
    </TaskItemGridWrapper>
  );
};

export default CardItem;
